// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4593":"bd15d426","6447":"bcf3e678","7945":"bd15d426","8542":"bd15d426","8552":"944c80fb"}[chunkId] + ".chunk.css";
};